import React, { FC, useEffect, useState } from 'react';
import s from './toysBlock.module.scss';
import { useTranslation } from '@hooks/useTranslation';
import { Checkbox } from '@components/UIKit/Checkbox/Checkbox';
import { Button } from '@components/UIKit/Button/Button';
import cn from 'classnames';
import { ICartItemToys } from '@services/store/helpers/cart';
interface Props {
  list: ICartItemToys[];
  selectedFigures: ICartItemToys[];
  setSelectedFigures: React.Dispatch<React.SetStateAction<ICartItemToys[]>>;
  deleteSelectedHandler: () => void;
}
export const ToysBlockHeader: FC<Props> = ({
  list,
  selectedFigures,
  setSelectedFigures,
  deleteSelectedHandler
}) => {
  const {
    translate: tr
  } = useTranslation();
  const [isAllSelected, setIsAllSelected] = useState(false);
  useEffect(() => {
    const selectedLength = selectedFigures.map(item => ({
      ...item,
      figures: item.figures.filter(({
        status
      }) => status !== 'store.item.ended')
    })).filter(({
      figures
    }) => !!figures.length).flatMap(({
      figures
    }) => figures).length;
    const listLength = list.map(item => ({
      ...item,
      figures: item.figures.filter(({
        status
      }) => status !== 'store.item.ended')
    })).filter(({
      figures
    }) => !!figures.length).flatMap(({
      figures
    }) => figures).length;
    setIsAllSelected(selectedLength === 0 ? false : selectedLength === listLength);
  }, [selectedFigures, list]);
  const selectAllHandler = () => {
    setSelectedFigures(isAllSelected ? [] : list.map(item => ({
      ...item,
      figures: item.figures.filter(figure => figure.status !== 'store.item.ended')
    })).filter(({
      figures
    }) => !!figures.length));
  };
  return <div className={s.cartBlock__header} data-sentry-component="ToysBlockHeader" data-sentry-source-file="ToysBlockHeader.tsx">
            <Checkbox name={'select_all'} onChange={selectAllHandler} checked={isAllSelected} label={tr({
      id: 'cart.page.select.all'
    })} data-sentry-element="Checkbox" data-sentry-source-file="ToysBlockHeader.tsx" />
            <Button id='default_button' className={cn(s.cartBlock__deleteAll, !selectedFigures.length && s.cartBlock__deleteAll_hide, '_desktop')} color={'Transparent-Red'} size={'small'} onClick={deleteSelectedHandler} data-sentry-element="Button" data-sentry-source-file="ToysBlockHeader.tsx">
                {tr({
        id: 'cart.page.delete.selected'
      })}
            </Button>
            <Button id='default_button' className={cn(s.cartBlock__deleteAll, !selectedFigures.length && s.cartBlock__deleteAll_hide, '_mobile')} color={'Light-Red'} size={'small'} onClick={deleteSelectedHandler} icons={{
      left: {
        name: 'trash'
      }
    }} data-sentry-element="Button" data-sentry-source-file="ToysBlockHeader.tsx" />
        </div>;
};